import { useCallback, useRef, useState } from 'react';
import { share } from '../../../../../utils/share';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconChecked } from '../../../../icon/IconChecked';
import { IconCopy } from '../../../../icon/IconCopy';
import { Button } from '../../../../input/Button';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { COPY_TIMEOUT } from './constants';
import { AdvertisingCopyButtonProps } from './types';

export const AdvertisingCopyButton: React.FC<AdvertisingCopyButtonProps> = ({ url, ...other }) => {
    const t = useTranslation();

    const [isCopied, setIsCopied] = useState(false);
    const timer = useRef<number | undefined>();

    const onCopy = useCallback(async () => {
        await share({ url });

        setIsCopied(true);

        clearTimeout(timer.current);

        // @ts-ignore
        timer.current = setTimeout(() => {
            setIsCopied(false);
        }, COPY_TIMEOUT);
    }, [url]);

    return (
        <Button
            size="m"
            color={isCopied ? 'primary' : 'secondary'}
            width="100%"
            onClick={onCopy}
            {...other}
        >
            <Flex direction="row" alignItems="center" spacing={0.5}>
                {isCopied ? (
                    <IconChecked size="16px" color="var(--color-invert)" />
                ) : (
                    <IconCopy size="16px" color="var(--color-primary)" />
                )}
                <Typography variant="caption" weight="bold" color={isCopied ? 'invert' : 'primary'}>
                    {isCopied ? t('Скопировано') : t('Ссылка')}
                </Typography>
            </Flex>
        </Button>
    );
};
